/**
 * Custom hook for programs data
 */

import { useApi } from './useApi';
import { fetchProgramsData } from '@/lib/api/programs';

export function useProgramsData() {
  return useApi(fetchProgramsData, []);
}
